import React, { useState } from 'react';
import axios from 'axios';
import InputForm from './components/InputForm';
import './App.css';  // Import the CSS file

const App = () => {
  const [apiResponse, setApiResponse] = useState(null);
  const [isCalculating, setIsCalculating] = useState(false); // State to manage button status

  const handleFormSubmit = (inputs) => {
    console.log('Form submitted, starting calculation...');
    setIsCalculating(true); // Set the button to "Calculating..." state

    axios.post('https://ftqeg8j5f4.execute-api.us-east-1.amazonaws.com/automatic_deployment_stage/irr-npv-calculator', inputs)
      .then(response => {
        console.log('API Response:', response.data);  // Log the API response
        setApiResponse(response.data);
      })
      .catch(error => {
        console.error('There was an error!', error);
      })
      .finally(() => {
        console.log('Finished API call, setting isCalculating to false');
        setIsCalculating(false); // Revert the button back to "Submit" after the response or error is handled
      });
  };

  return (
    <div>
      <h1>Financial Calculator</h1>
      <InputForm onSubmit={handleFormSubmit} isCalculating={isCalculating} /> {/* Pass the state to the form */}

      {/* Handle Redirect Case */}
      {apiResponse?.redirect ? (
        <div className="redirect-message">
          <h2>
            {apiResponse.email} is not part of our email list.<br />
            <br />
            To use this free calculator: <br />
            1. Join in the box below.<br />
            2. Click the link in the email you'll receive to confirm.<br />
            3. Return here and your email address will work!
          </h2>
        </div>
      ) : (
        apiResponse && (
          <div style={{ padding: '0 20px' }}> {/* Add padding for left and right space */}
            <h2>Returns</h2>
            <table style={{ marginBottom: '20px', fontSize: '13px', lineHeight: '0.2' }}> {/* Slightly increased font size and reduced line height */}
              <thead>
                <tr>
                  <th style={{ textAlign: 'center' }}>Year</th>
                  <th style={{ textAlign: 'center' }}>NPV</th>
                  <th style={{ textAlign: 'center' }}>IRR (%)</th>
                </tr>
              </thead>
              <tbody>
                {apiResponse.returns.map((item, index) => (
                  <tr key={index}>
                    <td>{item.year}</td>
                    <td>${item.npv.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                    <td>{item.irr.toFixed(1)}%</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <h2>Cash Flows</h2>
            <table style={{ fontSize: '13px', lineHeight: '0.2' }}> {/* Slightly increased font size and reduced line height */}
              <thead>
                <tr>
                  <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Year</th>
                  <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Without Investment</th>
                  <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>With Investment</th>
                  <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Incremental Cash Flow</th>
                  <th style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Discounted Incremental Cash Flow</th>
                </tr>
              </thead>
              <tbody>
                {apiResponse.cashFlows.map((item, index) => (
                  <tr key={index} style={index === apiResponse.cashFlows.length - 1 ? { fontWeight: 'bold' } : {}}> {/* Bold the last row */}
                    <td>{item.year}</td>
                    <td>${item.withoutInvestment.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                    <td>${item.withInvestment.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                    <td>${item.incremental_cf.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                    <td>${item.dicsounted_incremental_cf.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
};

export default App;